import React from 'react';
import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SkillsMarquee from './components/SkillsMarquee';
import Capabilities from './components/Capabilities';
import Projects from './components/Projects';
import About from './components/About';
import Footer from './components/Footer';

function App() {
  return (
    <div className="site-root">
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <SkillsMarquee />
        <Capabilities />
        <Projects />
        <About />
      </main>
      <Footer />
    </div>
  );
}

export default App;
